import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
// import MuiSelect from '../../../../SegmentBuilder/Shared/MuiSelect';
import { MuiSearchField } from "../../../../SegmentBuilder/Shared/MuiTextField";
import { Clear, Search } from "@mui/icons-material";
import pixabayLogo from "@assets/images/pixabay.svg";
import { onActivateKeyDown } from "../../../../../utils/keyboardActivate";

function Header({
  selectedEngine,
  handleEngineChange,
  items,
  imageKeyword,
  handleChangeImageKeyword,
  fieldPlaceHolder = "Search Images",
  showIcon = true,
  iconPosition = "start",
  onSearch,
}) {
  const canNavigateToPixabay = imageKeyword && imageKeyword.trim().length > 2;
  const openPixabaySearch = () => {
    if (!canNavigateToPixabay) return;
    const q = encodeURIComponent(imageKeyword.trim());
    window.open(`https://pixabay.com/images/search/${q}/`, "_blank");
  };
  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "start", marginBottom: 20 }}
      >
        <img
          role="button"
          tabIndex={canNavigateToPixabay ? 0 : -1}
          aria-disabled={!canNavigateToPixabay}
          aria-label={
            canNavigateToPixabay
              ? "Search Pixabay for this keyword in a new tab"
              : "Pixabay"
          }
          src={pixabayLogo}
          alt={"pixabay"}
          style={{
            height: 32,
            width: 88,
            cursor: canNavigateToPixabay ? "pointer" : "default",
          }}
          title={canNavigateToPixabay ? "Search on Pixabay" : undefined}
          onClick={openPixabaySearch}
          onKeyDown={onActivateKeyDown(
            openPixabaySearch,
            canNavigateToPixabay
          )}
        />
      </div>
      <div
        style={{
          position: "sticky",
          top: 0,
          background: "white",
          zIndex: 10,
          marginLeft: "1px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ width: "80%" }}>
          <MuiSearchField
            placeholder={fieldPlaceHolder}
            showIcon={showIcon}
            iconPosition={iconPosition}
            value={imageKeyword}
            handleChange={handleChangeImageKeyword}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSearch && onSearch();
              }
            }}
            sx={{ borderRadius: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: imageKeyword.length > 0 && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleChangeImageKeyword("")}
                    size="small"
                  >
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div
          style={{ width: "15%", display: "flex", justifyContent: "flex-end" }}
        >
          <IconButton
            onClick={onSearch}
            aria-label="search"
            style={{
              width: 40,
              height: 35,
              borderRadius: 4,
              background: "var(--Primary-Purple-500, #9B5AF8)",
              opacity: 1,
              color: "white",
            }}
          >
            <Search fontSize="small" />
          </IconButton>
        </div>
      </div>
    </>
  );
}

export default Header;
